import type { ModelDefinition } from "@/__main__/data-model.mjs";
import { player } from "@/game-fortnite/models/player.mjs";

export const PlayerMatchKill = {
  id: String,
  killed: player,
  killer: player,
} satisfies ModelDefinition;
